import React from 'react'

interface FramePointProps {
  removePoint?: basic.ReactMouseHandler
  movePoint?: basic.ReactMouseHandler
}

const FramePoint: React.FC<FramePointProps> = ({ removePoint, movePoint }) => {
  const handleEvent = (e: React.MouseEvent, action?: basic.ReactMouseHandler) => {
    e.stopPropagation()
    if (action) action(e)
  }

  return (
    <div
      className='place__point'
      onMouseDown={e => handleEvent(e, movePoint)}
      onDoubleClick={e => handleEvent(e, removePoint)} />
  )
}

export default FramePoint